import { makeStyles } from '@material-ui/core';

export const useOwnerCardStyles = makeStyles((theme) => ({
  status: {
    display: 'flex',
    width: '100%',
    justifyContent: 'right',
  },
  actions: {
    position: 'relative',
    // [theme.breakpoints.down('xs')]: {
    //   flex: 1,
    // },
  },
  actionButton: {
    width: '24px',
    cursor: 'pointer',
  },
  delete: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-end',
    },
    '& > img': {
      padding: '1px',
    },
  },
  menu: {
    marginTop: '4px',
    width: 137,
    position: 'absolute',
    right: 0,
    borderRadius: '6px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    overflowY: 'hidden',
    height: 0,
    border: '1px solid rgba(255, 255, 255, 0.10)',
    background: '#3A3A40',
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.40), 0px 8px 25px 0px rgba(40, 40, 40, 0.60)',
    zIndex: 2,
    '& span': {
      color: 'white',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '20px',
      marginLeft: 8,
    },
  },
  openedMenu: {
    height: 'auto',
  },
  itemMenu: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '12px',
    '&:first-child': {
      borderBottom: '1px solid #FFFFFF1A',
    },
  },
  leftItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
}));
